<div class="transaction-details-modal">
  <div class="modalHeader">
    <ion-icon name="arrow-back-outline" (click)="dismissModal()" class="close-button"></ion-icon>
    <h2>Transaction Details</h2>
  </div>
  <ion-card>
    <ion-card-content>
      <!-- Transaction details content goes here -->
      <p class="detail-item">
        Date:
        <span class="detail-value">January 1, 2024</span>
      </p>
      <p class="detail-item">
        Category:
        <span class="detail-value">
          Subscription
        </span>
      </p>
      <p class="detail-item">
        Description:
        <span class="detail-value">
          BOOK TRANSFER CUSTOMER REF
        </span>
      </p>
      <p class="detail-item">
        Status:
        <span class="detail-value">
          Cleared
        </span>
      </p>
      <p class="detail-item">
        Tax:
        <span class="detail-value">
          $150.00
        </span>
      </p>
      <p class="detail-item">
        Amount:
        <span class="detail-value">
          $1,500.00
        </span>
      </p>
    </ion-card-content>
  </ion-card>



</div>